<template>
  <div>
    <b-container>
      <b-row class="mt-md-5 ml-md-5">
        <b-col class="mt-2 mt-md-5 ml-md-5">
          <h4>Willkommen beim Standrohrverleihservice der evm.</h4>
        </b-col>
      </b-row>

      <b-row class="ml-md-5">
        <b-col class="mt-5 ml-md-5">
          <b>Einsatzort des Standrohrs:</b>
        </b-col>
      </b-row>
      <b-row class="ml-md-5">
        <b-col class="ml-md-5 col-9 col-md-4 col-lg-3 mt-3 mt-md-2">
          <label for="street" class="label">Straße</label>
          <b-input
            id="street"
            ref="street"
            type="text"
            v-model="street"
            :state="stateStreet"
            aria-describedby="street-feedback"
            @keyup.enter="validateAndSave()"
            maxlength="100">
          </b-input>
          <b-form-invalid-feedback id="street-feedback">
            {{msgStreet}}
          </b-form-invalid-feedback>
        </b-col>
        <b-col class="ml-md-2 col-9 col-md-4 col-lg-3 mt-3 mt-md-2">
          <label for="houseno" class="label">Hausnummer</label>
          <b-input
            id="houseno"
            ref="houseno"
            type="text"
            v-model="houseNo"
            :state="stateHouseNo"
            aria-describedby="houseNo-feedback"
            @keyup.enter="validateAndSave()"
            maxlength="20">
          </b-input>
          <b-form-invalid-feedback id="houseNo-feedback">
            {{msgHouseNo}}
          </b-form-invalid-feedback>
        </b-col>
      </b-row>

      <b-row class="ml-md-5">
        <b-col class="ml-md-5 col-9 col-md-4 col-lg-3 mt-3 mt-md-2">
          <label for="zip" class="label">Postleitzahl</label>
          <b-input
            id="zip"
            ref="zip"
            type="text"
            v-model="zip"
            :state="stateZip"
            aria-describedby="zip-feedback"
            @keyup.enter="validateAndSave()"
            @change="checkZip()"
            maxlength="5">
          </b-input>
          <b-form-invalid-feedback id="zip-feedback">
            {{msgZip}}
          </b-form-invalid-feedback>
        </b-col>
        <b-col class="ml-md-2 col-9 col-md-4 col-lg-3 mt-3 mt-md-2">
          <label for="city" class="label">Ort</label>
          <b-input
            id="city"
            ref="city"
            type="text"
            v-model="city"
            :state="stateCity"
            aria-describedby="city-feedback"
            @keyup.enter="validateAndSave()"
            maxlength="100">
          </b-input>
          <b-form-invalid-feedback id="city-feedback">
            {{msgCity}}
          </b-form-invalid-feedback>
        </b-col>
      </b-row>

      <b-row class="ml-md-5">
        <b-col class="ml-md-5 col-9 col-md-4 col-lg-3 mt-3 mt-md-2">
          <label for="connection" class="label">Anschlusstyp <b-icon icon="info-circle"  style="color: #F39100" aria-hidden="true" id="connection-info"  @click="$bvModal.show('show-connectors')"></b-icon></label>
          <b-form-select
            id="connection"
            name="connection"
            v-model="selectedConnection" :options="connections"
            aria-describedby="connection-feedback"
            @keyup.enter="validateAndSave()"
            :state="stateConnection">
          </b-form-select>
          <b-form-invalid-feedback id="connection-feedback">
            {{msgConnection}}
          </b-form-invalid-feedback>
        </b-col>
        <b-col class="ml-md-2 col-9 col-md-4 col-lg-3 mt-3 mt-md-2">
          <label for="useCase" class="label">Verwendungszweck</label>
          <b-form-select
            id="useCase"
            name="useCase"
            v-model="selectedUseCase" :options="useCases"
            aria-describedby="useCase-feedback"
            @keyup.enter="validateAndSave()"
            :state="stateUseCase">
          </b-form-select>
          <b-form-invalid-feedback id="useCase-feedback">
            {{msgUseCase}}
          </b-form-invalid-feedback>
          <div style="font-size: x-small">Die Ausgabe von Standrohren zur Poolbefüllung ist nicht gestattet.</div>
        </b-col>
      </b-row>
      <b-row class="ml-md-5">
        <b-col class="ml-md-5 col-9 col-md-4 col-lg-3 mt-3 mt-md-2">
          <label for="useUntil" class="label">Voraussichtliche Rückgabe bis</label>
          <b-input
            id="useUntil"
            ref="useUntil"
            type="date"
            v-model="useUntil"
            :state="stateUseUntil"
            aria-describedby="useUntil-feedback"
            @keyup.enter="validateAndSave()"
            maxlength="10">
          </b-input>
          <b-form-invalid-feedback id="useUntil-feedback">
            {{msgUseUntil}}
          </b-form-invalid-feedback>
          <div style="font-size: x-small">Das ist der Zeitraum der voraussichtlichen Nutzungsdauer.</div>
        </b-col>
      </b-row>
      <b-row class="ml-md-5 mt-3" v-if="msgError">
        <b-col class="ml-md-2 ml-md-5 text-danger">{{msgError}}&nbsp;</b-col>
      </b-row>
      <b-row class="ml-md-5 mt-3">
        <b-col class="col-9 col-md-4 col-lg-3 ml-md-5 mt-3 mt-md-2">
          <div v-if="selectedCustType !== 'communal'">Schritt 2 von 3</div>
          <div v-if="selectedCustType === 'communal'">Schritt 2 von 2</div>
        </b-col>
        <b-col class="ml-md-2 col-9 col-md-4 col-lg-3 mt-3 mt-md-2" >
          <b-container class="no-gutters p-0">
            <b-row class="no-gutters ">
              <b-col class="d-flex flex-row">
                <b-button
                  class="ml-md-auto"
                  @click="back()"
                  @keyup.enter="back()"
                >
                  Zurück
                </b-button>
              </b-col>
              <b-col class="d-flex flex-row">
                <b-button
                  class="ml-md-auto"
                  @click="validateAndSave()"
                >
                  <div v-if="selectedCustType !== 'communal'">Weiter</div>
                  <div v-if="selectedCustType === 'communal'">Bestellen</div>
                </b-button>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
      <b-row class="mt-5">
        <b-col>&nbsp;</b-col>
      </b-row>
    </b-container>

    <cookie-consent
      message="Unsere Webseite verwendet Cookies. Informationen zu den verwendeten Cookies und weitere datenschutzrechtliche Hinweise finden Sie in unseren"
      linkLabel="Datenschutzhinweisen."
      href="https://www.evm.de/evm/Homepage/Impressum/#datenschutz"
      buttonLabel="Akzeptieren"
    />
    <b-modal id="zip-warning" hide-footer hide-header size="md">
      <div class="d-block text-center">
        Bitte beachten Sie, dass für dieses Gebiet der Standrohrverleih nur für "Am Autobahn-Kreuz" möglich ist.
      </div>
      <b-button class="mt-3" block @click="$bvModal.hide('zip-warning')">OK</b-button>
    </b-modal>
    <b-modal id="show-connectors" size="lg" ok-only hide-header>
      <b-container>
        <b-row>
          <b-col>
            <h4>Anschlusstypen</h4>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="col-lg-6 col-md-6 col-sm-12 col-12">
            <b>1 Zoll</b><br>
            <a :href="require('../../assets/con_one_in.jpg')" target="_blank"><b-img :src="require('../../assets/con_one_in_sm.jpg')" fluid-grow ></b-img></a>
          </b-col>
          <b-col class="col-lg-6 col-md-6 col-sm-12 col-12">
            <b>C-Anschluss</b><br>
            <a :href="require('../../assets/con_c_type.jpg')" target="_blank"><b-img :src="require('../../assets/con_c_type_sm.jpg')" fluid-grow ></b-img></a>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>

<script>

import { ApiCalls } from '@/scripts/ApiCalls'
import { BIcon } from 'bootstrap-vue'

export default {
  name: 'StandrohrStart',
  components: { BIcon },
  data () {
    return {
      selectedCustType: null,
      street: '',
      stateStreet: null,
      msgStreet: '',
      houseNo: '',
      stateHouseNo: null,
      msgHouseNo: '',
      zip: '',
      stateZip: null,
      msgZip: '',
      city: '',
      stateCity: null,
      msgCity: '',
      selectedConnection: null,
      stateConnection: null,
      msgConnection: '',
      connections: [
        { value: null, text: 'Bitte wählen', disabled: true },
        { value: '1 Zoll', text: '1 Zoll (Gartenschlauch)' },
        { value: 'C-Anschluss', text: 'C-Anschluss (Feuerwehrschlauch)' }
      ],
      selectedUseCase: null,
      stateUseCase: null,
      msgUseCase: '',
      useCases: [
        { value: null, text: 'Bitte wählen', disabled: true },
        { value: 'Gartenbewässerung', text: 'Gartenbewässerung' },
        { value: 'Bauwasser (Hausbau)', text: 'Bauwasser (Hausbau)' },
        { value: 'gewerbliche Nutzung', text: 'gewerbliche Nutzung' },
        { value: 'Gastronomie', text: 'Gastronomie' }
      ],
      useUntil: '',
      stateUseUntil: null,
      msgUseUntil: '',
      msgError: ''
    }
  },
  created () {
    if (localStorage.customerId) {
      this.msgError = ''
      this.selectedCustType = localStorage.selectedCustType
      if (localStorage.useSteet) {
        this.street = localStorage.useSteet
      }
      if (localStorage.useHouseNo) {
        this.houseNo = localStorage.useHouseNo
      }
      if (localStorage.useZip) {
        this.zip = localStorage.useZip
      }
      if (localStorage.useCity) {
        this.city = localStorage.useCity
      }
      if (localStorage.connectionType) {
        this.selectedConnection = localStorage.connectionType
      }
      if (localStorage.useCase) {
        this.selectedUseCase = localStorage.useCase
      }
      if (localStorage.useUntil) {
        this.useUntil = localStorage.useUntil
      }
    } else {
      this.$router.replace({ name: 'standrohrStart' })
    }
  },
  methods: {
    saveLocal () {
      localStorage.useSteet = this.street
      localStorage.useHouseNo = this.houseNo
      localStorage.useZip = this.zip
      localStorage.useCity = this.city
      localStorage.connectionType = this.selectedConnection
      localStorage.useCase = this.selectedUseCase
      localStorage.useUntil = this.useUntil
    },
    back () {
      this.saveLocal()
      this.$router.replace({ name: 'standrohrStart' })
    },
    validateAndSave () {
      let save = true
      this.msgError = ''
      if (!this.street) {
        this.msgStreet = 'Bitte Straße eingeben.'
        this.stateStreet = false
        save = false
      } else {
        this.msgStreet = ''
        this.stateStreet = null
        if (this.zip && this.zip === '56330') {
          if ((!/^(AM|am|Am)? ?(Autobahn|autobahn|AUTOBAHN){1}(-| ){1}(Kreuz|kreuz|KREUZ){1} ?$/u.test(this.street))) {
            this.msgStreet = 'Für dieses Gebiet ist leider nur "Am Autobahn-Kreuz" zulässig.'
            this.stateStreet = false
            save = false
          }
        } else if (!/^[\p{L}\w &.'-]+$/u.test(this.street)) {
          this.msgStreet = 'Die Straße enthält ungültige Zeichen. Erlaubt sind Zahlen, Buchstaben und Zeichen wie .-&'
          this.stateStreet = false
          save = false
        }
      }

      if (!this.houseNo) {
        this.msgHouseNo = 'Bitte Hausnummer eingeben.'
        this.stateHouseNo = false
        save = false
      } else {
        this.msgHouseNo = ''
        this.stateHouseNo = null
        if (!/^[\w äüöß&.'-]+$/i.test(this.houseNo)) {
          this.msgHouseNo = 'Die Hausnummer enthält ungültige Zeichen. Erlaubt sind Zahlen, Buchstaben und Zeichen wie .-&'
          this.stateHouseNo = false
          save = false
        }
      }

      if (!this.zip) {
        this.msgZip = 'Bitte Postleizahl eingeben.'
        this.stateZip = false
        save = false
      } else {
        this.msgZip = ''
        this.stateZip = null
        if (!/^[\d]{5}$/.test(this.zip)) {
          this.msgZip = 'Ungültige Postleitzahl. Bitte 5 Zahlen eingeben.'
          this.stateZip = false
          save = false
        }
      }

      if (!this.city) {
        this.msgCity = 'Bitte Ort eingeben.'
        this.stateCity = false
        save = false
      } else {
        this.msgCity = ''
        this.stateCity = null
        if (!/^[a-z äüöß&-]+$/i.test(this.city)) {
          this.msgCity = 'Der Ort enthält ungültige Zeichen. Erlaubt sind Buchstaben und -'
          this.stateCity = false
          save = false
        }
      }

      if (!this.selectedConnection) {
        this.stateConnection = false
        this.msgConnection = 'Bitte Anschlusstyp auswählen.'
        save = false
      } else {
        this.stateConnection = null
        this.msgConnection = ''
      }

      if (!this.selectedUseCase) {
        this.stateUseCase = false
        this.msgUseCase = 'Bitte Verwendungszweck auswählen.'
        save = false
      } else {
        this.stateUseCase = null
        this.msgUseCase = ''
      }
      if (!this.useUntil) {
        this.msgUseUntil = 'Bitte Datum im Format 31.01.2020 eingeben.'
        this.stateUseUntil = false
        save = false
      } else {
        console.log('check date: ' + this.useUntil)
        this.msgUseUntil = ''
        this.stateUseUntil = null
        if (/^[0-3][0-9][/.][0-3][0-9][/.](?:[0-9][0-9])?[0-9][0-9]$/.test(this.useUntil) || /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/.test(this.useUntil)) {
          console.log('date is valid')
          let now = new Date()
          let then = new Date(this.useUntil)
          if (then <= now) {
            this.msgUseUntil = 'Datum muss in der Zukunft liegen.'
            this.stateUseUntil = false
            save = false
          }
        } else {
          console.log('Date is not valid')
          this.msgUseUntil = 'Bitte Datum im Format 31.01.2020 eingeben.'
          this.stateUseUntil = false
          save = false
        }
      }
      if (save) {
        this.saveLocal()
        ApiCalls.safeSecondForm(localStorage.customerId, this.street, this.houseNo, this.zip,
          this.city, this.selectedConnection, this.selectedUseCase, this.useUntil).then(res => {
          console.log(res)
          if (isNaN(res)) {
            if (res === 'OK') {
              this.$router.replace({ name: 'callback' })
            } else if (res.startsWith('ERROR')) {
              if (res === 'ERROR-ZIP') {
                this.stateZip = false
                this.msgZip = 'Die eingegebene PLZ liegt nicht in unserem Versorgungsgebiet. Bitte wenden Sie sich an ihr zuständiges Wasserwerk.'
              } else {
                this.msgError = 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.'
              }
            }
          } else {
            localStorage.customerId = res
            this.$router.replace({ name: 'standrohr-3' })
          }
        }).catch(error => {
          console.log(error)
          this.msgError = 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.'
        })
      }
    },
    checkZip () {
      if (this.zip && this.zip === '56330') {
        console.log(this.zip + ' match')
        this.$bvModal.show('zip-warning')
      }
    }
  }
}
</script>

<style lang="css">

  .btn-evm-orange {
    background-color: rgb(243, 145, 0);
    border-color: rgb(243, 145, 0);
  }

  .btn-evm-orange:hover {
    background-color: rgb(243, 145, 0);
    border-color: rgb(243, 145, 0);
  }

  .form-control {
    padding-right: 1px !important;
    padding-left: 5px !important;
  }
</style>

<style lang="scss">
  /*
    CookieConsent
  */
  @import "../../scss/cookie-consent";
  @import "../../scss/cookie-consent-bottom";
  @import "../../scss/cookie-consent-transition";
  /*
    Bootstrap
  */
  @import "~bootstrap/scss/bootstrap";
</style>
